<template>
  <div>
    <search-form
      :fetchData="fetch"
      ref="searchFormRef"
      :handelSearch="handelSearch"
      :collection="formCollection"
      addText="导出"
      :addBtnLoading="exporting"
      :handelAdd="handelExport"
    ></search-form>
    <a-table
      :columns="columns"
      :row-key="(record) => record.uuid"
      :data-source="tableData"
      :pagination="false"
      :loading="loading"
      @change="handleTableChange"
      :scroll="{x: 3300, y: 600}"
      size="small"
    >
      <template #bodyCell="{ column, record }">
        <table_data_format
          :record="record"
          :column="column"
        ></table_data_format>
      </template>
    </a-table>
  </div>
</template>
<script setup>
  import { ref, onMounted, toRefs, computed } from 'vue'
  import { useStore } from 'vuex'
  import {
    getData,
    exportReport,
  } from '@/api/system_report/vehicle_type_report'
  import { message } from 'ant-design-vue'
  import dayjs from 'dayjs'
  import { inOrOut } from '@/utils/common'
  import searchForm from '@/components/search_form'
  import table_data_format from '@/components/table_data_format'
  import { constantToOptions } from '@/utils/format'
  import { fileExport } from '@/utils/download'
  //初始化
  const pageName = '车型出入园统计'
  const idField = 'date' //响应数据的id的字段名
  const store = useStore()
  const Enum = toRefs(store.state.common)

  //1、搜索框
  const formCollection = [
    {
      type: 'select',
      field: 'type',
      storeOptions: 'areaType',
      defaultValue: 1,
      label: '园区类型',
      width: '130px',
    },
    {
      type: 'select',
      field: 'inOrOut',
      options: constantToOptions(inOrOut),
      defaultValue: 'inCounts',
      label: '出入园',
      width: '130px',
    },
    {
      type: 'dateRange',
      startField: 'start_time',
      endField: 'end_time',
      label: '时间',
      defaultStart: dayjs().subtract(7, 'day').format('YYYY-MM-DD'),
      defaultEnd: dayjs().format('YYYY-MM-DD'),
    },
  ]
  const searchFormRef = ref()
  function handelSearch() {
    pagination.value.current = 1
    fetch()
  }

  //2、表格
  const tableTitle = ref([])
  const columns = computed(
    () =>
      tableTitle?.value &&
      tableTitle.value.map((title) => ({
        title: title.name,
        dataIndex: title.key,
        key: title.key,
        align: 'left',
        fixed: title.key === 'date' ? 'left' : '',
      }))
  )
  const tableData = ref([])
  const loading = ref(false)
  const pagination = ref({
    current: 1,
    pageSize: 10,
    showLessItems: true,
    showQuickJumper: true,
    showSizeChanger: true,
  })

  function handleTableChange(page) {
    pagination.value = { ...pagination.value, ...page }
    fetch()
  }

  function fetch() {
    //获取表单值
    const formState = searchFormRef.value?.formState

    loading.value = true
    getData(
      {
        // size: pagination.value.pageSize,
        // pn: pagination.value.current,
        // ...formState,
        start_time: formState.start_time,
        end_time: formState.end_time,
        type: formState.type,
      },
      formState.inOrOut
    ).then(({ data }) => {
      loading.value = false
      tableData.value = data.list
      tableTitle.value = data.title
      pagination.value.total = data.total
    })
  }
  onMounted(fetch)

  //导出
  const exporting = ref(false)
  async function handelExport() {
    exporting.value = true
    const formState = searchFormRef.value?.formState
    fileExport({
      onFinally: () => (exporting.value = false),
      name: `车型出入园统计${Enum.areaType.value[formState.type]}导出${
        formState.start_time
      }至${formState.end_time}.xlsx`,
      url: `/api/v2/statistics/vehicleType/${formState.inOrOut}Export?start_time=${formState.start_time}&end_time=${formState.end_time}&type=${formState.type}`,
    })
  }
</script>
